import _ from "underscore";
import { Macros } from "../models/Macros";
import API from "../lib/TimeEditAPI";
import { TExternalSearchCriteria } from "../lib/FilterUtils";
import { useAppContext } from "../contexts/AppContext";

/**
 * Utilize selection pane and its object list from outside
 */
export const useObjectSelectMacros = (sourceId: string) => {
    const { fireEvent } = useAppContext();

    const selectType = (type, showSearchSettings = false, callback = _.noop) => {
        fireEvent(sourceId, Macros.Event.SELECT_EXTERNAL_TYPE, type, () => {
            if (showSearchSettings) {
                fireEvent(sourceId, Macros.Event.SHOW_SEARCH_SETTINGS, {});
            }
            callback();
        });
    };

    const applySearchCriteria = (
        searchCriteria: TExternalSearchCriteria | any[],
        openSearchSettings = false,
        callback: (criteria?: any) => void = _.noop
    ) => {
        const doApply = (criteria) => {
            fireEvent(
                sourceId,
                Macros.Event.SET_EXTERNAL_OBJECT_SEARCH_CRITERIA,
                { searchCriteria: criteria },
                () => {
                    const type = criteria.type ?? (criteria.length === 1 && criteria[0].type);
                    if (type) {
                        selectType(type, openSearchSettings, () => callback(criteria));
                    } else {
                        callback(criteria);
                    }
                }
            );
        };

        if (Array.isArray(searchCriteria) || !searchCriteria.type) {
            doApply(searchCriteria);
            return;
        }
        API.getTypesByExtid(_.asArray(searchCriteria.type), false, (result) => {
            doApply({ ...searchCriteria, type: result[0] });
        });
    };

    return { selectType, applySearchCriteria };
};
